const swiper = new Swiper('.swiper', {

  // Default parameters
  slidesPerView: 'auto',
  spaceBetween: 5,
  grabCursor: true,
  centeredSlides: true,

  // Responsive breakpoints
  breakpoints: {
    // when window width is >= 968px
    968: {
      spaceBetween: 10
    }
  },

  navigation: false,
  pagination: {
    enabled: true,
    clickable: false,
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
    pauseOnMouseEnter: false,
  },
  loop: true,

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
  },

  // Navigation arrows
  // navigation: {
  //   nextEl: '.swiper-button-next',
  //   prevEl: '.swiper-button-prev',
  // },
});
